import React from "react";
import Select from "react-select";
import { useField, useFormikContext } from "formik";
import { useTranslation } from "react-i18next";

type OptionType = { label: string; value: string | number };

type FormikReactSelectProps = {
  label: string;
  isRequired?: boolean;
  fieldName: string;
  options: OptionType[];
  placeholder?: string;
  className?: string;
  isDisabled?: boolean;
};

const FormikReactSelect: React.FC<FormikReactSelectProps> = ({
  label,
  isRequired = false,
  fieldName,
  options,
  placeholder,
  className = "",
  isDisabled = false,
}) => {
  const { t } = useTranslation();
  const [field, meta] = useField(fieldName);
  const { setFieldValue } = useFormikContext();

  const selectedOption = options.find(option => option.value === field.value);

  return (
    <div className={className}>
      <label className="form-label">
        {`${t(label)}${isRequired ? " *" : ""}`}
      </label>

      <Select
        name={fieldName}
        options={options}
        value={selectedOption || null}
        onChange={(option: OptionType | null) => setFieldValue(fieldName, option?.value || "")}
        placeholder={placeholder || t("Επιλέξτε")}
        isDisabled={isDisabled}
        classNamePrefix="react-select"
      />

      {meta.touched && meta.error && (
        <div className="text-danger">{meta.error}</div>
      )}
    </div>
  );
};

export default FormikReactSelect;
